import { useCallback } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import {
    AddonsCartButtonWrapper,
    AddonsCartBadgeStyled,
} from "app/components/AddonsCart/AddonsCartButton/AddonsCartButtonStyled";
import { AddonsCartTooltip } from "app/components/AddonsCart/AddonsCartTooltip";
import { useAddonsCart } from "app/components/hooks/useAddonsCart";
import { allTrackers } from "app/services/track/track";

export const AddonsCartButton = () => {
    const { totalCartItems, onCartClick, isAddonsCartButtonEnabled, addonsFromCookies } = useAddonsCart();

    const handleCartIconClick = useCallback(() => {
        allTrackers.dispatchTrackEvent("Button", "click", `cart icon/add ons (${addonsFromCookies})`);
        onCartClick();
    }, [addonsFromCookies, onCartClick]);

    if (!isAddonsCartButtonEnabled) {
        return null;
    }

    return (
        <AddonsCartButtonWrapper>
            <AddonsCartTooltip parent="button">
                <IconButton
                    onClick={handleCartIconClick}
                    type="flat"
                    iconName="showcase-shopping"
                    iconSize="sm"
                    iconColor={colorsPalettes.blue[400]}
                />
            </AddonsCartTooltip>
            {totalCartItems > 0 ? (
                <AddonsCartBadgeStyled
                    type="number"
                    bgColor={colorsPalettes.red["400_P"]}
                >
                    <Text fontVariant="tag">{totalCartItems}</Text>
                </AddonsCartBadgeStyled>
            ) : null}
        </AddonsCartButtonWrapper>
    );
};
